import React from "react";

export const TicketContext = React.createContext();
